import { ILanguage } from '@bimser/core';
import { ICulture } from '../../../system/culture/entities';
import { ILocation } from '../../../system/location/entities';
import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Configuration') => ({
	GetLocationList: new GetMethod<Array<ILocation>, null>({
		service,
		controller,
		method: 'GetLocationList'
	}),
	GetLanguageList: new GetMethod<Array<ILanguage>, null>({
		service,
		controller,
		method: 'GetLanguageList'
	}),
	GetCultureList: new GetMethod<Array<ICulture>, null>({
		service,
		controller,
		method: 'GetCultureList'
	}),
	GetConfiguration: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetConfiguration'
	})
});

export { getMethods };
